<svg viewBox="0 0 12 10">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1274 0.587173C8.99979 -0.35365 6.75391 -0.219485 5.62508 1.3955C4.49667 -0.219485 2.25037 -0.35365 1.1228 0.587173C-2.95712 3.98935 5.37544 9.86416 5.62508 10C5.87472 9.86416 14.2069 3.98935 10.1274 0.587173Z" fill="#FB6264"/>
</svg>
